module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"All new messages"},"et":{"title":"All new messages"},"ru":{"title":"All new messages"}}')
  delete Component.options._Ctor
}
